import React from "react";
import { MetricLabel } from "../../MetricCards";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "../../utils/formatters";

export function AnalyticsCohortsBlock({ cohorts }) {
  return (
    <div className={analyticsStyles.block}>
      <h3>Когорты</h3>
      {cohorts.rows.length > 0 ? (
        <div className={panelStyles.tableWrap}>
          <table className={panelStyles.table}>
            <thead>
              <tr>
                <th><MetricLabel title="Когорта (неделя)" hint="Неделя регистрации (понедельник)." /></th>
                <th><MetricLabel title="Пользователи" hint="Размер когорты." /></th>
                <th><MetricLabel title="Удержание D1" hint="Доля когорты, активная на день 1." /></th>
                <th><MetricLabel title="Удержание D7" hint="Доля когорты, активная на день 7." /></th>
                <th><MetricLabel title="Удержание D30" hint="Доля когорты, активная на день 30." /></th>
                <th><MetricLabel title="Aha %" hint="Доля когорты, достигших Aha." /></th>
                <th><MetricLabel title="Покупка %" hint="Доля когорты, совершивших покупку." /></th>
                <th><MetricLabel title="ARPPU (платные)" hint="Выручка (amount>0) / уникальные платящие пользователи (amount>0) в когорте." /></th>
                <th><MetricLabel title="LTV (платные)" hint="Lifetime LTV по когорте: сумма amount>0 / уникальные платящие пользователи (amount>0)." /></th>
              </tr>
            </thead>
            <tbody>
              {cohorts.rows.map((row) => (
                <tr key={row.cohort}>
                  <td>{row.cohort}</td>
                  <td>{formatNumber(row.size)}</td>
                  <td>{formatPercent(row.retentionD1)}</td>
                  <td>{formatPercent(row.retentionD7)}</td>
                  <td>{formatPercent(row.retentionD30)}</td>
                  <td>{formatPercent(row.ahaRate)}</td>
                  <td>{formatPercent(row.purchaseRate)}</td>
                  <td>{formatMoney(row.arppu)}</td>
                  <td>{formatMoney(row.ltvPaid ?? row.ltv)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={panelStyles.note}>Нет данных для когорт.</div>
      )}
      {cohorts.insights?.length ? <div className={panelStyles.note}>{cohorts.insights.join(" ")}</div> : null}
    </div>
  );
}

export default AnalyticsCohortsBlock;
